import {
	Button,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Grid,
	GridItem,
	Input,
	Select,
} from "@chakra-ui/react";
import { format } from "date-fns";

import { formatCurrency } from "@/utils/currency";
import { COLORS, CURRENCY_TO_LOCALE_STRING, INVOICE_STATUS } from "@/common/constants";
import { InspectorInvoice } from "@/types/invoiceInspectors.interface";
import { Form, Formik } from "formik";

interface ModalInvoiceConfirmationProps {
	isOpen: boolean;
	approvalStatus: string;
	errorMessageApproval: string;
	errorMessageNote: string;
	selectedDataView: InspectorInvoice | undefined;
	onClose: () => void;
	handleChangeApprovalStatus: (value: string) => void;
	handleChangeNote: (value: string) => void;
	handleConfirmToCancel: () => void;
	handleConfirm: (approvalStatus: string) => Promise<void>;
}

const ModalInvoiceConfirmation = ({
	isOpen,
	onClose,
	handleChangeNote,
	handleConfirmToCancel,
	handleConfirm,
	handleChangeApprovalStatus,
	approvalStatus,
	selectedDataView,
	errorMessageApproval,
	errorMessageNote,
}: ModalInvoiceConfirmationProps) => {
	return (
		<Modal onClose={onClose} isOpen={isOpen} isCentered size="xl">
			<ModalOverlay />
			<Formik
				initialValues={{ status: "" }}
				onSubmit={async values => {
					await handleConfirm(values.status)
					handleChangeApprovalStatus(values.status)
				}}
			>
				{formik => (
					<Form>

						<ModalContent borderRadius={15} padding={"10px"}>
				<ModalHeader>Invoice Approval</ModalHeader>
				<ModalCloseButton
					onClick={handleConfirmToCancel}
					_focus={{ outline: "none", boxShadow: "none" }}
							/>
				<ModalBody marginTop={0}>
					<Grid templateColumns="repeat(2, 1fr)" gap={6}>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>Invoice ID</p>
							<p>{selectedDataView?.invoiceNumber}</p>
						</GridItem>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>
								Invoice Date
							</p>
							<p>
								{selectedDataView
									? format(selectedDataView?.invoiceDate, "dd-MM-yyyy")
									: "-"}
							</p>
						</GridItem>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>
								Company Name
							</p>
							<p>{selectedDataView?.companyName || "-"}</p>
						</GridItem>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>Location</p>
							<p>
								{selectedDataView?.location +
									", " +
									selectedDataView?.country || "-"}
							</p>
						</GridItem>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>Vessel Name</p>
							<p>{selectedDataView?.shipName || "-"}</p>
						</GridItem>
						<GridItem w="100%" h="10">
							<p style={{ marginBottom: 5, fontWeight: "bold" }}>Amount</p>
							<p>
								{selectedDataView
									? formatCurrency(
										selectedDataView.amount,
										selectedDataView.currency,
										CURRENCY_TO_LOCALE_STRING[selectedDataView.currency]
									)
									: "-"}
							</p>
						</GridItem>
					</Grid>
					<div style={{ marginTop: 50 }}>
						<p style={{ marginBottom: 5, fontWeight: "bold" }}>Status</p>
						<Select
										name="status"
										fontSize="12px"
										cursor="pointer"
										borderColor={errorMessageApproval ? "red" : "gray"}
										onChange={formik.handleChange}
									>
							<option key="none" value={-1}>
								Please select...
							</option>
							<option key="approved" value={INVOICE_STATUS.APPROVED}>
								Approve
							</option>
							<option key="rejected" value={INVOICE_STATUS.REJECTED}>
								Reject
							</option>
						</Select>
						{errorMessageApproval && (
							<p style={{ fontSize: "14px", color: "red" }}>
								{errorMessageApproval}
							</p>
						)}
						{approvalStatus === "3" && (
							<>
								<p
									style={{ marginTop: 5, marginBottom: 5, fontWeight: "bold" }}
											>
									Note
								</p>
								<Input
									placeholder="Input your note here"
									onChange={(e: any) => handleChangeNote(e.target.value)}
									borderColor={errorMessageNote ? "red" : "gray"}
											/>
								{errorMessageNote && (
									<p style={{ fontSize: "14px", color: "red" }}>
										{errorMessageNote}
									</p>
								)}
							</>
						)}
					</div>
				</ModalBody>
				<ModalFooter
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "flex-end",
						gap: 10,
					}}
							>
					<Button
									disabled={formik.isSubmitting}
									onClick={handleConfirmToCancel}
									borderColor="#D0D5DD"
									bgColor="white"
								>
						Cancel
					</Button>
					<Button
									type="submit"
									disabled={formik.isSubmitting}
									isLoading={formik.isSubmitting}
									loadingText="Submitting"
									bgColor={COLORS.BUTTON.BACKGROUND}
									color={COLORS.BUTTON.FOREGROUND}
								>
						Save
					</Button>
				</ModalFooter>
			</ModalContent>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default ModalInvoiceConfirmation;
